module.exports = __webpack_public_path__ + "img/lv2.eb250401.png";